import {get, post, put} from './index';

const localMode = process.env.REACT_APP_LOCAL_MODE === 'true';

const enrich = records => {
  records.forEach(record => {
    record.Employee.FullName = `${record.Employee.FirstName} ${record.Employee.LastName}`;
  });
  return records;
}

export const getLoa = async () => {
  let loaRecords = [];

  if (localMode) {
    return new Promise(resolve => {  
      setTimeout(() => {
        resolve(enrich(require('./mock-data/loa.json')));
      }, 500);
    });
  } else {
    loaRecords = await get(`/loa`);
  } 

  return enrich(loaRecords);
};

export const postLoa = async (loa) => {
  return await post(`/loa_create`, loa);
}

export const putLoa = async (loa) => {
  return await put(`/loa_edit`, loa);
} 

export const cancelLoa = async (id) => {
  return await put(`/loa_cancel`, {'ID': id});
}
